
import { FETCH_THIRDPARYDATA_DETAIL_BEGIN, FETCH_THIRDPARYDATA_DETAIL_FAILURE, FETCH_THIRDPARYDATA_DETAIL_SUCCESS } from "../constants/thirdPartyData";
const initialState = {
    ThirdPartyList: [],
    ThirdPartyDetails: null,
    ThirdPartyDetailsLoading:false,
    ThirdPartyListLoading:false,
    ThirdPartyListError: null,
    ThirdPartyDetailsError:null,
}


export const getThirdPartyDataReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_THIRDPARYDATA_DETAIL_BEGIN: {
            return {
                ...state,
                ThirdPartyDetailsLoading: true,
                ThirdPartyDetails:null,
                error: null,
            };
        }
        case FETCH_THIRDPARYDATA_DETAIL_FAILURE:
            return {
                ...state,
                ThirdPartyDetailsLoading: true,
                ThirdPartyDetails:null,
                error: payload.errorMessage
            };
        case FETCH_THIRDPARYDATA_DETAIL_SUCCESS:
            return {
                ...state,
                ThirdPartyDetailsLoading: false,
                ThirdPartyDetails:payload.ThirdPartyDataDetails,
                error: null,
            };
        default:
            return state;
    }
}

export default getThirdPartyDataReducer
